import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { fuseAnimations } from '@fuse/animations';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { DialogService } from 'app/dialogs/dialog.service';
import { TypeOfGroup } from 'app/enums/types-groups.enum';
import { AlertHistory } from 'app/models/alerts/alert-list.model';
import { ChatMessageItem } from 'app/models/chat-message-item.model';
import { ChatMessageData } from 'app/models/comment.model';
import { Item } from 'app/models/item.inferface';
import { UserModel } from 'app/models/user.model';
import { WorkflowStepInstanceSection, WorkflowStepInstanceSectionCompletion, workflowStepInstanceSectionLog, workflowStepInstanceSectionLogToSave } from 'app/models/workflow/workflow-step-instance.interface';
import { SimpleFileUploaderComponent } from 'app/modules/simple-file-uploader/simple-file-uploader.component';
import { AuthService } from 'app/services/auth.service';
import { MVLocalStorageService } from 'app/services/mv-local-storage.service';
import { PublicFilesService } from 'app/services/public-files.service';
import { ToastService } from 'app/services/toast.service';
import { WorkflowService } from 'app/services/workflow.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-consultants-panel',
  templateUrl: './consultants-panel.component.html',
  styleUrls: ['./consultants-panel.component.scss'],
  animations: fuseAnimations,
  encapsulation: ViewEncapsulation.None
})
export class ConsultantsPanelComponent implements OnInit {

  public userGroupsConsultants: Item[] = [];

  @Input() viewMode = false;
  @Input() canAddDeleteSections = false;
  @Input() currentStepStatus: string;
  @Input() sections: WorkflowStepInstanceSection[] = [];

  sectionsMock = [
    {
      id: 1,
      title: 'mock 1',
      detail: 'mock 1',
      consultants: [1],
      consultantGroups: [],
      readonly: false,
      completed: false,
      workflowStepInstanceSectionLogs: [
        {
          workflowStepInstanceSectionId: 1,
          id: 1,
          message: 'log 1',
          attachments: [],
          createdBy: 'Nacho',
          createdDate: new Date().toString(),
        },
        {
          workflowStepInstanceSectionId: 1,
          id: 2,
          message: 'log 2',
          attachments: [],
          createdBy: 'Nacho',
          createdDate: new Date().toString(),
        }
      ]
    },
    {
      id: 2,
      title: 'mock 2',
      detail: 'mock 2',
      consultants: [1],
      consultantGroups: [],
      readonly: true,
      completed: false,
      workflowStepInstanceSectionLogs: [
        {
          workflowStepInstanceSectionId: 2,
          id: 3,
          message: 'log 3',
          attachments: [],
          createdBy: 'Mati',
          createdDate: new Date().toString(),
        }
      ]
    },
  ];

  @Output() sectionsEmitter: EventEmitter<void> = new EventEmitter();

  @Output() sectionsToSave: EventEmitter<void> = new EventEmitter();

  loading = false;

  form: UntypedFormGroup;
  newSectionForm: UntypedFormGroup;
  maxLength = 1024;

  // newSections: WorkflowStepInstanceSection[] = [];
  
  @ViewChild('fileUploader', {static: true})
  private fileUploader: SimpleFileUploaderComponent;
  @ViewChildren(SimpleFileUploaderComponent)
  private fileUploaders: QueryList<SimpleFileUploaderComponent>;

  user: UserModel;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private auth: AuthService,
    private toast: ToastService,
    private workflowService: WorkflowService,
    private fileService: PublicFilesService
  ) {
    this.user = auth.currentUser;
  }

  ngOnInit(): void {
    // this.sections = this.sectionsMock;
    // console.log(this.sections);
    this.sections.map(x => {
      if(x.consultants.find(id => id == this.user.userId)){
        x.readonly = false;
      }else{
        x.readonly = true;
      }
    });

    this.sections.sort((a,b) => a.readonly < b.readonly ? -1 : +(a.readonly > b.readonly))

    this.form = this.formBuilder.group({
      newsDetail: [],
      news: this.formBuilder.array([], Validators.required)
    });

    this.newSectionForm = this.formBuilder.group({
      newSections: this.formBuilder.array([], Validators.required)
    });

    this.workflowService.getUserGroups(TypeOfGroup.Consultants).subscribe(
      res => {
        this.userGroupsConsultants = res;
      },
      err => {
        this.toast.error(err);
      }
    );

    this.sections.forEach(section => this.addNewsDetailForm());

   
  }

  getSerializedSections(): WorkflowStepInstanceSection[] {
    let serializedSections: WorkflowStepInstanceSection[] = [];

    this.newSections().controls.forEach(form => {
      serializedSections.push({
        id: 0,
        title: form.value.title,
        detail: form.value.detail,
        consultants: form.value.consultants.id ? [form.value.consultants.id] : [],
        consultantGroups: form.value.consultantGroups,
        readonly: false,
        completed: false
      })
    });

    this.sections.forEach(section => {
      serializedSections.push(section);
    })

    return serializedSections;
  }

  // #region New Sections 

  newSections(): UntypedFormArray {
    return this.newSectionForm.get('newSections') as UntypedFormArray;
  }

  newSection(): UntypedFormGroup {
    return this.formBuilder.group({
      title: ['', Validators.required],
      detail: ['', Validators.required],
      consultants: [[]],
      consultantGroups: [[]]
    })
  }

  addNewSection(): void {
    this.newSections().push(this.newSection());
  }

  removeNewSection(i: number): void {
    this.newSections().removeAt(i);
  }

  // #endregion New Sections

  // #region Initial Sections

  news(): UntypedFormArray {
    return this.form.get('news') as UntypedFormArray;
  }

  newsDetailForm(): UntypedFormGroup {
    return this.formBuilder.group({
      newsDetail: ['', Validators.required]
    })
  }

  addNewsDetailForm(): void {
    this.news().push(this.newsDetailForm());
  }

  downloadNewsFiles(file) {
    // console.log(file);
    // const downloadLink = document.createElement('a');
    // downloadLink.href = file.url;
    // downloadLink.download = file.name;
    // downloadLink.click();

    this.fileService.downloadFileTemplate(file.id).subscribe();
  }

  uploadFile(i) {
    // console.log(i);
    // console.log(this.news().controls);
    this.fileUploaders.get(i)?.openSelectFile();
  }

  isNewsDetailValid(i: number): boolean {
    return this.news().controls[i].get('newsDetail').valid;
  }

  postNews(section: WorkflowStepInstanceSection, i: number) {
      const newSectionLog: workflowStepInstanceSectionLogToSave = {
        workflowStepInstanceSectionId: section.id,
        message: this.news().controls[i].get('newsDetail').value,
        attachments: this.fileUploaders.get(i)?.files?.map(x => x.id) ?? []
      };

      this.workflowService.saveWorkflowStepInstanceSectionLog(newSectionLog)
        .subscribe(
          value => {
            this.sectionsEmitter.emit();
          },
          err => this.toast.error(err));

      this.news().controls[i].get('newsDetail').setValue('');
      this.fileUploaders.get(i)?.rawFiles?.map(file => {
        this.fileUploaders.get(i)?.removeFile(file);
      });
  }

  removeInitialSection(i: number): void {
    this.news().removeAt(i);
    this.sections.splice(i, 1);
  }

  setSectionCompletion(section: WorkflowStepInstanceSection) {
    // console.log(section);

    if(section.id !== 0){
      const param: WorkflowStepInstanceSectionCompletion = {
        workflowStepInstanceSectionId: section.id,
        isCompleted: !section.completed
      };
      
      this.workflowService.saveSectionCompletion(param)
        .subscribe(() => section.completed = !section.completed,
                    err => this.toast.error(err));
    }else{
      section.completed = !section.completed;
      this.sectionsToSave.emit();
    }
  }

  // #endregion

}
